import FilterTextField from '../baseInputTypes/FilterTextField'

type Props = {}
export const Keywords = (props: Props) => {
  return (
    <FilterTextField
      label="Keywords"
      fieldPath={'advancedTextSearching.keyword'}
    />
  )
}
